import { COLOR } from './colors';
export const textFieldTheme = {
    MuiInputBase: {
        styleOverrides: {
            input: {
                color: COLOR.textColor.secondary,
                lineHeight: '24px',
                height: '24px',
                '&:disabled': {
                    color: COLOR.textColor.tertiary,
                },
            },
            root: {
                '&:disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'unset',
                },
            },
        },
    },
    MuiFormHelperText: {
        styleOverrides: {
            contained: {
                lineHeight: '16px',
                letterSpacing: '0.4px',
                margin: '4px 16px',
            },
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            asterisk: {
                color: '#EB5757',
                // '&$error': {
                //   color: '#EB5757'
                // },
            }
        }
    },
    MuiOutlinedInput: {
        styleOverrides: {
            notchedOutline: {
                borderColor: COLOR.textColor.tertiary,
                '&:hover': {
                    borderColor: COLOR.textColor.secondary,
                },
            },
        },
    },
};
